<template>
  <iframe v-if="htmlPreview" src="about:blank" :srcdoc="htmlPreview" class="w-full h-full" />
</template>

<script>
export default {
  props: {
    emailCampaign: {
      type: Object,
      required: true,
    },
  },
  computed: {
    htmlPreview() {
      return this.emailCampaign?.email_message?.email_message_preview?.html || null;
    },
  },
};
</script>
